import { Map, List } from 'immutable'

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export function selectAuth (state) {
  return state.auth || Map()
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectAuthorized (state) {
  return !!state.auth.get('jwt', '')
}

/**
 * @param {ReduxState} state redux state
 * @returns {String}
 */
export function selectUsername (state) {
  return state.auth.get('username', '')
}

/**
 * @param {ReduxState} state redux state
 * @returns {List}
 */
export function selectUserSubscriptions (state) {
  return state.auth.get('subscriptions', List())
}

/**
 * @param {ReduxState} state redux state
 * @returns {String}
 */
export function selectUserCountry (state) {
  return state.auth.get('country', '')
}
